export interface SetupWhopCompanyBinding {
  influencerId: string;
  companyId: string;
}

/** Persisted Whop company on the influencer doc, or a just-created company for the same influencer only. */
export function resolveEffectiveWhopCompanyId(
  persistedCompanyId: string | undefined,
  influencerId: string | undefined,
  setupBinding: SetupWhopCompanyBinding | undefined,
): string | undefined {
  if (persistedCompanyId) {
    return persistedCompanyId;
  }
  if (influencerId && setupBinding?.influencerId === influencerId) {
    return setupBinding.companyId;
  }
  return undefined;
}
